import type { Auction } from "../services/auctionService";
import type { ApiShirt } from "../types/Shirt";

function isFutureTimestamp(value: unknown, nowMs: number): boolean {
  if (typeof value !== "string") return false;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) && parsed > nowMs;
}

export function hasActiveAuction(
  shirt: ApiShirt,
  auction?: Auction,
  nowMs: number = Date.now(),
): boolean {
  if (auction && isFutureTimestamp(auction.end_time, nowMs)) {
    return true;
  }

  return isFutureTimestamp(shirt.auction_end_time, nowMs);
}


